import { makeStyles } from '@material-ui/core/styles'

// Any time that we would like to add CSS to our Components we will create a styles object. The syntax is different then normal CSS. Please notice that camel case is used to set the list-style-type. For your reference please visit https://v4.mui.com
export const parkingButtonPanelStyles = makeStyles((theme) => ({
  parkingButtonPanelContainer: {
    position: 'absolute',
    top: '55px',
    left: '10px',
    width: 'auto',
    height: 'auto',
    display: 'flex',
    padding: 3,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  parkingButtonPanelContainerMobile: {
    position: 'absolute',
    top: '160px',
    left: '10px',
    width: 'auto',
    height: 'auto',
    display: 'flex',
    padding: 3,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  parkingPermitOverlay: {
    position: 'absolute',
    top: '55px',
    left: '85px',
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10,
    background: theme.palette.base.yellow,
    color: theme.color.almostBlack,
    textAlign: 'left',
  },
  enabledButton: {
    color: theme.palette.backgroundColor.main,
    padding: 1,
    background: theme.palette.components.parkingLotIcons,
    borderRadius: '0.5rem',
    marginBottom: 3,
    '&:hover': {
      background: theme.palette.components.parkingLotIcons,
    },
  },
  disabledButton: {
    color: theme.palette.backgroundColor.main,
    padding: 1,
    background: theme.palette.components.parkingLotDisabledIcons,
    borderRadius: '0.5rem',
    marginBottom: 3,
    '&:hover': {
      background: theme.palette.components.parkingLotDisabledIcons,
    },
  },
  enabledAllParkingLotsButton: {
    color: theme.palette.backgroundColor.main,
    padding: 1,
    background: theme.palette.components.allParkingButtonEnabled,
    borderRadius: '0.5rem',
    marginBottom: 3,
    '&:hover': {
      background: theme.palette.components.allParkingButtonEnabled,
    },
  },
  disabledAllParkingLotsButton: {
    color: theme.palette.backgroundColor.main,
    padding: 1,
    background: theme.palette.components.allParkingButtonDisabled,
    borderRadius: '0.5rem',
    marginBottom: 3,
    '&:hover': {
      background: theme.palette.components.allParkingButtonDisabled,
    },
  },
  enabledAdditionalSettingsParkingLotsButton: {
    color: theme.palette.backgroundColor.main,
    padding: 1,
    background: theme.palette.button.hoverDarkInverted,
    borderRadius: '0.5rem',
    '&:hover': {
      background: theme.palette.button.hoverDarkInverted,
    },
  },
  disabledAdditionalSettingsParkingLotsButton: {
    color: theme.palette.backgroundColor.main,
    padding: 1,
    background: theme.palette.components.additionalSettingsButtonDisabled,
    borderRadius: '0.5rem',
    '&:hover': {
      background: theme.palette.components.additionalSettingsButtonDisabled,
    },
  },
  busStopsButton: {
    color: theme.palette.backgroundColor.main,
    background: theme.palette.base.red,
    '&:hover': {
      background: theme.palette.base.red,
    },
  },
  disabledBusStopsButton: {
    color: theme.palette.backgroundColor.main,
    background: theme.palette.components.busStopsIconDisabled,
    '&:hover': {
      background: theme.palette.components.busStopsIconDisabled,
    },
  },
  additionalSettingsContainer: {
    position: 'absolute',
    background: theme.palette.paper.secondary,
    borderRadius: '1rem',
    left: '100%',
    top: '1%',
    padding: 5,
    marginLeft: 10,
  },
  purchaseButton: {
    color: 'white',
    background: theme.color.rutgersRed,
    '&:hover': {
      color: 'white',
      background: theme.color.rutgersRed,
    },
  },
}))

export default parkingButtonPanelStyles
